(function($){

	var docReady = function(){
		// Code goes here :)
	};

	$(document).ready(function(){
		docReady();
	});

})(jQuery);